<template lang="pug">
.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/report")
          i.fa.fa-chart-line
          span.ml-1 {{ $t("title.reports") }}
      b-breadcrumb-item
        router-link(to="/report/transferHistory")
          i.fa.fa-list-alt
          span.ml-1 {{ $t("title.transfer_history") }}
  .row
    .col-md-12
      .form-row
        .col-xs-10.col-sm-6.col-md-4.col-lg-4.mb-1
          b-input-group(size="sm")
            b-input-group-text(slot="prepend")
              i.icon-user
            DebounceInput(
              type="search"
              v-model.trim.lazy="search_id"
              :placeholder="$t('ui.account_id')"
            )
            b-input-group-text(slot="append").p-0
              .btn.btn-append(@click="back()")
                i.fa.fa-chevron-left
                span {{ $t("ui.back") }}
        //- .col-xs-10.col-sm-6.col-md-3.col-lg-3.mb-1
        //-   DateRangePicker(:title="$t('ui.date_range')" :value="dateRange")
        .col-xs-2.col-sm-2.col-md-2.col-lg-2.mb-1
          SubmitButton(
            icon="fa fa-search"
            :text="$t('ui.search')"
            type="button"
            @click="submit"
            variant="success"
            size="sm"
          )

  .row
    .col-md-12
      .card.mb-1
        .card-header.p-2.bg-gradient-light
          .d-flex.align-items-center.justify-content-start
            i.fa.fa-history.mr-2
            span.mr-2 {{ $t("title.transfer_history") }}
            .tag(v-if="search_id") {{ search_id }}
        .card-body.p-1
          b-row
            .col-md-10
              b-pagination.float-left(
                size="sm"
                hide-ellipsis
                :total-rows="totalRows"
                :per-page="perPage"
                v-model="currentPage"
                @input="changedPage($event)").mb-1
            .col-md-2
              b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                b-form-select(:options="$store.getters.pageSizeOptions" :value="perPage" @input="changedPageSize")
          b-row
            .col-sm-12.col-md-12.col-lg-12.col-xl-12
              .table-responsive.m-0(style="width: 600px;")
                table#transferHistory.table.b-table.c-table(role="table", aria-busy="false")
                  thead(role="rowgroup")
                    tr(role="row")
                      th(role="columnheader", scope="col", style="width: 160px;")
                        div {{ $t("ui.date") }}
                      th.text-left(role="columnheader", scope="col")
                        div {{ $t("ui.type") }}
                      th.text-right(role="columnheader", scope="col", style="width: 200px;")
                        div {{ $t("ui.amount") }}

                  tbody(v-if="list.length > 0" role="rowgroup")
                    template(v-for="(item, index) in list")
                      tr(role="row")
                        td(role="cell")
                          .text-left.text-primary
                            span.text-primary {{ $moment(item.transfer_on).format('DD/MM/YYYY') }}
                            span.text-zero {{ $moment(item.transfer_on).format('HH:mm:ss A') }}
                        td.text-left
                          span {{ item.transfer_type }}
                        td
                          .text-right
                            span(
                              :class="$helpers.getNumberClass(item.transfer_amount)"
                              )
                              | #[b {{ item.transfer_amount | currency }}]
                  tbody(v-else)
                    tr
                      td(colspan=7)
                        .text-center.p-0
                          span.text-zero {{ $t('message.no_records') }}

  #end-report.mt-3

</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, email, sameAs, numeric, decimal, helpers } from "vuelidate/lib/validators";

import config from "@/config";
import errorTags from "@/errorTags";

import DateRangePicker from "@/library/DateRangePicker.vue";
import DebounceInput from "@/library/DebounceInput";
import ValidateResult from "@/library/ValidateResult";
import SubmitButton from "@/library/SubmitButton.vue";
import currency from "@/components/currency.vue";

import xhr from "@/plugins/xhr.js";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    ValidateResult,
    DateRangePicker,
    currency
  },
  data() {
    return {
      report_type: "ALL",
      target_id: "",
      search_id: "",
      lines: [],
      list: [],
      total: {},
      currentPage: 1,
      totalRows: 0,
      account_id: "",
      sortBy: "account_id",
      sortDesc: false
    };
  },
  validations: {},
  computed: {
    fields() {
      return [
        {
          key: "account_id",
          label: this.$t("ui.account_id"),
          sortable: true,
          thStyle: {
            width: "200px"
          }
        },
        {
          key: "account_balance",
          label: this.$t("ui.balance"),
          class: "text-right",
          thStyle: {
            width: "160px"
          }
        },
        {
          key: "full_name",
          label: this.$t("ui.profile"),
          class: "text-left"
        }
      ];
    },
    perPage() {
      return this.$store.getters.pageSize;
    },
    direction() {
      return this.sortDesc ? "DESC" : "ASC";
    },
    dateRange() {
      return [this.$moment(this.$store.getters.dateRange[0]), this.$moment(this.$store.getters.dateRange[1])];
    }
  },
  mounted() {
    var q = this.$route.query;
    if (q["id"] != null) {
      this.search_id = q["id"];
      this.submit();
    }
  },
  methods: {
    back() {
      if (this.search_id) {
        this.$router.push("/account/accountList?id=" + this.search_id);
      }
    },
    changedPage(e) {
      this.currentPage = e;
      this.getList();
    },
    changedPageSize(e) {
      this.$store.dispatch("layout/setPageSize", e);
      this.currentPage = 1;
      this.submit();
    },
    sortingChanged(e) {
      if (e.sortBy !== this.sortBy) {
        this.sortDesc = false;
      } else {
        this.sortDesc = this.direction === "ASC";
      }
      this.sortBy = e.sortBy;
      this.submit();
    },
    submit() {
      this.getList();
    },
    getList() {
      if (this.search_id == null || this.search_id == "") {
        this.list = [];
        this.total = {};
        this.totalRows = 0;
        this.currentPage = 1;
        return;
      }

      var args = {
        session_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.username
      };
      args["member_id"] = this.search_id || null;
      args["page_number"] = parseInt(this.currentPage);
      this.currentPage = args["page_number"];
      args["page_size"] = this.perPage;
      xhr
        .doRequest(args, xhr.ACCOUNT.transferHistory)
        .then(res => {
          this.list = res.data.transfer_list;
          // if (res.data.total && res.data.total.length > 0) {
          //   this.total = res.data.total[0];
          // }
          this.totalRows = res.data.transfer_list.length > 0 ? res.data.transfer_list[0]["totalrows"] : 0;
          this.$root.$emit("bv::table::refresh", "transferHistory");
        })
        .catch(res => {
          this.$helpers.handleFeedback(res.status);
        });
    }
  }
};
</script>
